import s from './Courses.module.scss';
import { useGetCoursesQuery } from '../../../../redux/apis/coursesApi';
import { CourseCard } from '../CreateCourse/components/CourseCard/CourseCard';
import { useTranslation } from 'react-i18next';
import { PrimaryButton } from 'components/PrimaryButton/PrimaryButton';
import { useNavigate } from 'react-router-dom';
import { Skeleton } from 'components/Skeleton/Skeleton';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { TagsView } from 'components/TagsView/TagsView';
const URL = process.env.REACT_APP_API_ADDRESS

export const Courses = () => {

    // ### State 
    const [tag, setTag] = useState()
   
    const {i18n, t} = useTranslation()
    const navigate = useNavigate()
    const langs = useSelector((store: any) => store.main.langs);

    const {data: courses, isLoading: isGetLoading} = useGetCoursesQuery({ tag: tag })
    
    // ### Effects

    // ### Functions

    // ### Views
    const coursesView = courses?.courses?.map((course: any, index: number) => {
        const image = Object.entries(course?.image)?.reduce((acc: any, el: any) => {
            if(el[0] === "default_image" || el[0] === "isManual"){
                acc[el[0]] = el[1]
            }else{
                acc[el[0]] = `${URL}${el[1]}`
            }
            return acc
        },{})
        
        return(
            <div className={s.item} key={index}>
               
                <CourseCard 
                    id={course.id}
                    image={image}
                    title={course?.active_card_name ? course?.card_name?.[i18n.language] : course.name?.[i18n.language]}
                    description={course?.active_card_description ? course?.card_description?.[i18n.language] : course.description?.[i18n.language]}
                    active_price={course.active_price}
                    active_discount={course.active_discount}
                    price={course.price}
                    discount={course.discount}
                    type={"click"}
                    activeLang={langs?.[0]?.key}
                    form={course}
                /> 
            </div>  
        )
    })

    return(
        <div className={s.wrapper}>
            <div className={s.header}>
                <PrimaryButton 
                    text={t('courses.create')}
                    onClick={() => navigate('/courses/create')}
                    type={"button"}
                    style={{width: "fit-content"}}
                />
            </div>
            <div className={s.tabs_wrapper}>
                <TagsView
                    type="course"
                    setCurrentTag={setTag}
                />
            </div>
            <div className={s.content}>
                {coursesView}
            </div>
            <Skeleton isLoading={isGetLoading} />
        </div>
    )
}